import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import DealContext from '../DealContext';
import PickCustomer from '../PickCustomer';
import { modal } from '../../modal/ModalEmitter';
import ApiService from '../../../services/ApiService';

const LienholderCard = () => {
  const { deal, fetchDeal } = useContext(DealContext);

  const hasLienholder = !!deal.Lienholder;

  const handleLienholderSubmit = payload => {
    const { customerId } = payload;

    if (customerId) {
      return ApiService.put(`crm/deal/${String(deal.id)}/change-lienholder`, { customerId }).then(() => {
        modal.close();
        fetchDeal(); // TODO Perf
      });
    }
  };

  const handleLienholderSetup = () => {
    modal.open('pickCustomer', {
      style: 'center',
      size: 'sm',
      hideFooter: true,
      hidePrint: true,
      staticBackdrop: true,
      title: 'Lienholder',
      message: (
        <PickCustomer
          onSubmit={handleLienholderSubmit}
          filter={{
            Type: ['Lienholder'],
          }}
        />
      ),
    });
  };

  const handleRemoveLienholder = () => {
    // TODO Faster callback
    return ApiService.put(`crm/deal/${String(deal.id)}/remove-lienholder`).then(fetchDeal);
  };

  return (
    <Card className="customer-card">
      {hasLienholder ? (
        <>
          <div className="card-toolbar">
            <div className="card-toolbar-button" onClick={handleRemoveLienholder} title="Remove Lienholder">
              <i className="fas fa-trash fa-fw" />
            </div>
          </div>
          <Card.Body>
            <Card.Title>Lienholder</Card.Title>
            {`${deal.Lienholder.fullName} ${
              deal.Lienholder['Company Name'] !== deal.Lienholder.fullName ? `(${deal.Lienholder['Company Name']})` : ''
            }`}
            <br />
            <div>{deal.Lienholder.Address}</div>
            <div>
              {deal.Lienholder.City} {deal.Lienholder.State} {deal.Lienholder.Zip}
            </div>
            <div>{deal.Lienholder.Phone}</div>
          </Card.Body>
        </>
      ) : (
        <Card.Body className="p-0">
          <div className="setup-banner p-3" onClick={handleLienholderSetup}>
            <i className="fas fa-user-plus mr-2" /> Setup Lienholder
          </div>
        </Card.Body>
      )}
    </Card>
  );
};

export default LienholderCard;
